export class AntifraudeWarning {
    value: any;
    date: string;
    name: string;
    antifraudTitle: string;
    antifraudLabel: string;
    showAntifraudScreen: boolean;

    constructor(){}
  }


// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/antifraud-warning/antifraud-warning.ts